"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var shared_1 = require("../../../../shared");

var TableComponentBase =
/** @class */
function (_super) {
  __extends(TableComponentBase, _super);

  function TableComponentBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.orchestrateComponentStyle = function (componentStyleProps, initialStyle, styleQueries) {
      var componentStyle = initialStyle;
      var queryStore = _this.table.props.queryStore;

      if (queryStore && styleQueries) {
        componentStyle = queryStore.mergeQueriesAndProps({
          props: initialStyle || {},
          queries: styleQueries
        }, componentStyleProps);
      }

      return componentStyle;
    };

    return _this;
  }

  Object.defineProperty(TableComponentBase.prototype, "tableEvents", {
    get: function get() {
      return this.table && this.table.events || {};
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TableComponentBase.prototype, "eventsForElement", {
    get: function get() {
      return this.tableEventsKey && this.tableEvents[this.tableEventsKey] || {};
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TableComponentBase.prototype, "table", {
    get: function get() {
      return this.props.table;
    },
    enumerable: true,
    configurable: true
  });

  TableComponentBase.prototype.getRowKey = function (row, rowIndex) {
    if (row && row['_rowKey']) {
      return row['_rowKey'];
    }

    return "row_" + rowIndex;
  };

  TableComponentBase.prototype.getCellKey = function (row, rowIndex, column) {
    var id = column.id;
    return this.getRowKey(row, rowIndex) + "_" + (id || 'NO_ID');
  };

  TableComponentBase.prototype.getHeadRowKey = function (rowIndex) {
    return "head_row_" + rowIndex;
  };

  TableComponentBase.prototype.getHeadCellKey = function (rowIndex, columnIndex, column) {
    var id = column.id;
    return this.getHeadRowKey(rowIndex) + "_" + (id || 'NO_ID') + "_" + (columnIndex || -1);
  };

  TableComponentBase.prototype.getRowStyleProps = function (row, rowIndex, grouping) {
    var componentStyleProps = {
      row: row,
      rowIndex: rowIndex
    };
    var _a = this.table.props,
        rowStyle = _a.rowStyle,
        rowStyleQueries = _a.rowStyleQueries,
        rowClasses = _a.rowClasses;
    var className = this.table.getConditionalClassName(componentStyleProps, rowClasses);
    var componentStyle = this.orchestrateComponentStyle(componentStyleProps, rowStyle, rowStyleQueries);

    if (grouping) {
      var groupRowStyle = grouping.rowStyle,
          groupRowStyleQueries = grouping.rowStyleQueries,
          groupRowClasses = grouping.rowClasses;

      if (groupRowClasses && groupRowClasses.length > 0) {
        className = this.table.getConditionalClassName(componentStyleProps, groupRowClasses, className);
      }

      if (groupRowStyle || groupRowStyleQueries) {
        var groupComponentStyle = this.orchestrateComponentStyle(componentStyleProps, groupRowStyle, groupRowStyleQueries);
        componentStyle = ksys_app_template_1.utils.object.deepMergeObjects(componentStyle, groupComponentStyle);
      }
    }

    return {
      className: className,
      componentStyleProps: componentStyleProps,
      componentStyle: componentStyle
    };
  };

  TableComponentBase.prototype.getCellStyleProps = function (row, rowIndex, column, columnIndex, cellValue) {
    var cellStyle = column.cellStyle,
        cellStyleQueries = column.cellStyleQueries;
    var componentStyleProps = {
      row: row,
      rowIndex: rowIndex,
      column: column,
      columnIndex: columnIndex,
      cellValue: cellValue
    };
    var conditionalStyles = this.table.props.conditionalStyles;
    var componentStyle = this.orchestrateComponentStyle(componentStyleProps, cellStyle, cellStyleQueries);

    if (!ksys_app_template_1.utils.typeChecks.isNullOrEmpty(conditionalStyles)) {
      var conditonalsObj = {
        row: row,
        rowIndex: rowIndex,
        column: column,
        columnIndex: columnIndex,
        cellValue: cellValue
      };

      for (var _i = 0, conditionalStyles_1 = conditionalStyles; _i < conditionalStyles_1.length; _i++) {
        var conditionalStyle = conditionalStyles_1[_i];
        var conditionalHelper = new ksys_app_template_1.helpers.ConditionalHelper(conditionalStyle.conditional);

        if (conditionalHelper.matches(conditonalsObj)) {
          componentStyle = __assign(__assign({}, componentStyle), conditionalStyle.style);
        }
      }
    }

    var className = this.table.getConditionalClassName(componentStyleProps, column.cellClasses);
    return {
      className: className,
      componentStyleProps: componentStyleProps,
      componentStyle: componentStyle
    };
  };

  TableComponentBase.prototype.getHeadCellStyleProps = function (rowIndex, column, columnIndex) {
    var header = column.header,
        headCellStyle = column.headCellStyle,
        headCellStyleQueries = column.headCellStyleQueries;
    var componentStyleProps = {
      column: column,
      columnIndex: columnIndex,
      header: header
    };
    var conditionalHeadStyles = this.table.props.conditionalHeadStyles;
    var componentStyle = this.orchestrateComponentStyle(componentStyleProps, headCellStyle, headCellStyleQueries);

    if (!ksys_app_template_1.utils.typeChecks.isNullOrEmpty(conditionalHeadStyles)) {
      var conditonalsObj = {
        rowIndex: rowIndex,
        column: column,
        columnIndex: columnIndex,
        cellValue: header
      };

      for (var _i = 0, conditionalHeadStyles_1 = conditionalHeadStyles; _i < conditionalHeadStyles_1.length; _i++) {
        var conditionalStyle = conditionalHeadStyles_1[_i];
        var conditionalHelper = new ksys_app_template_1.helpers.ConditionalHelper(conditionalStyle.conditional);

        if (conditionalHelper.matches(conditonalsObj)) {
          componentStyle = __assign(__assign({}, componentStyle), conditionalStyle.style);
        }
      }
    }

    var className = this.table.getConditionalClassName(componentStyleProps, column.headCellClasses);
    return {
      className: className,
      componentStyleProps: componentStyleProps,
      componentStyle: componentStyle
    };
  };

  TableComponentBase.prototype.getEvents = function (eventsForElement, row, rowIndex, column, columnIndex, cellValue) {
    if (eventsForElement === void 0) {
      eventsForElement = {};
    }

    var response = {};
    var keys = Object.keys(eventsForElement);

    var _loop_1 = function _loop_1(key) {
      var handler = eventsForElement[key];

      response[key] = function (event) {
        return handler && handler(event, row, rowIndex, column, columnIndex, cellValue);
      };
    };

    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
      var key = keys_1[_i];

      _loop_1(key);
    }

    return response;
  };

  TableComponentBase.prototype.getTooltipHeaderProps = function (column, matchingProperties) {
    var queryStore = this.table.props.queryStore;
    var response;

    if (column && Array.isArray(column.tooltips) && column.tooltips.length > 0) {
      var tooltips = ksys_app_template_1.utils.collection.filterWithMatchingProperties(column.tooltips, matchingProperties);

      if (tooltips) {
        for (var i = 0; i < tooltips.length; i++) {
          var tooltip = tooltips[i];

          if (tooltip && tooltip.conditional && tooltip.conditional && queryStore) {
            var conditionalTooltipHelper = new ksys_app_template_1.helpers.ConditionalHelper(tooltip.conditional);

            if (conditionalTooltipHelper.matchesWithOptions({
              executionOptions: queryStore.executionOptions
            })) {
              response = tooltip;
              break;
            }
          } else if (tooltip) {
            response = tooltip;
            break;
          }
        }
      }
    }

    if (response) {
      var target = response.target,
          conditional = response.conditional,
          tooltipProps = __rest(response, ["target", "conditional"]);

      response = tooltipProps;
    }

    return response;
  };

  TableComponentBase.prototype.getTooltipRowProps = function (row, column) {
    var response;

    if (column && Array.isArray(column.tooltips) && column.tooltips.length > 0) {
      var tooltips = ksys_app_template_1.utils.collection.filterWithMatchingProperties(column.tooltips, {
        target: 'row'
      });

      if (tooltips) {
        for (var i = 0; i < tooltips.length; i++) {
          var tooltip = tooltips[i];

          if (tooltip && tooltip.conditional && tooltip.conditional) {
            var conditionalTooltipHelper = new ksys_app_template_1.helpers.ConditionalHelper(tooltip.conditional);

            if (conditionalTooltipHelper.matches(row)) {
              response = tooltip;
              break;
            }
          }
        }
      }
    }

    if (response) {
      var target = response.target,
          conditional = response.conditional,
          tooltipProps = __rest(response, ["target", "conditional"]);

      response = tooltipProps;
    }

    return response;
  };

  return TableComponentBase;
}(shared_1.ComponentBase);

exports.TableComponentBase = TableComponentBase;